module.exports = __webpack_public_path__ + "static/media/googleplay.03a48cb3.svg";